<template>
  <footer
    v-if="showPoweredBy && !isUiMode && !manualHiddenPoweredBy"
    class="i-footer fade-in-out"
    :class="{
      'fade-in-out-active': !isPanoramasListActive,
      'screen-ready': isScreenReady
    }"
    role="contentinfo"
  >
    <div class="footer-text-container">
      <a
        class="footer-text"
        href="https://www.istaging.com"
        target="_blank"
      >
        <span>Powered by iStaging</span>
      </a>
      <a
        class="footer-text"
        href="https://www.istaging.com/legal/privacy_policy"
        target="_blank"
      >
        <span>Privacy policy</span>
      </a>
      <a
        class="footer-text"
        href="https://www.istaging.com/legal/terms_of_service"
        target="_blank"
      >
        <span>Terms of use</span>
      </a>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import queryStr from '../../api/query-string'

export default {
  name: 'IFooter',
  computed: {
    ...mapGetters([
      'isPanoramasListActive',
      'isScreenReady',
      'isUiMode',
      'showPoweredBy'
    ]),
    manualHiddenPoweredBy () {
      return queryStr.hidePoweredBy
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.i-footer {
  @extend .absolute-full-width
  bottom: 0
  display: flex
  opacity: 0
  transform: translateY(20px)
  transition: .3s opacity ease-out, .3s transform ease-out
  pointer-events: none

  &.screen-ready {
    opacity: 1
    transform: none
  }
}

.footer-text-container {
  display: flex
  justify-content: flex-start
  margin: 0 $footer-text-pos 16px
  transform: scale(.83) // font-size: 10px
  transform-origin: left center

  & > * {
    pointer-events: auto
  }

  & > a {
    @media (max-width: $response - 1) {
      display: none
    }
  }

}

.footer-text {
  position: relative
  z-index: $footer-text-z
  font-size: 12px

  & + .footer-text {
    margin-left: 12px
    padding-left: 12px

    &::before {
      position: absolute
      content: ''
      height: 100%
      width: 1px
      background-color: $white
      top: 0
      left: 0
      bottom: 0
    }
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .footer-text-container {
    transform-origin: right center
  }

  .footer-text {
    & + .footer-text {
      margin-left: 0
      padding-left: 0
      margin-right: 12px
      padding-right: 12px

      &::before {
        left: auto
        right: 0
      }
    }
  }
}
</style>
